export type TotalsInput = {
  orderType?: string;
  subtotal: number;
  deliveryCharges?: number;
  discount?: number;
  tax?: number;
  taxPercent?: number;
  pricesIncludeTax?: boolean;
  grandtotal: number;
  discountBreakdown?: {
    applied?: string;
    promoCode?: string | null;
  };
};

const near = (a: number, b: number) => Math.abs(a - b) <= 0.05;

export const taxFromTotals = (totals: {
  subtotal?: number;
  discount?: number;
  deliveryCharges?: number;
  tax?: number;
  grandtotal?: number;
  taxPercent?: number;
  pricesIncludeTax?: boolean;
}) => {
  const subtotal = Number(totals.subtotal) || 0;
  const discount = Number(totals.discount) || 0;
  const delivery = Number(totals.deliveryCharges) || 0;
  const tax = Number(totals.tax) || 0;
  const grand = Number(totals.grandtotal) || 0;
  const taxable = Math.max(subtotal - discount, 0);
  const pricesIncludeTax =
    totals.pricesIncludeTax ?? near(grand, subtotal - discount + delivery);
  let taxPercent = totals.taxPercent;
  if (taxPercent == null && tax > 0) {
    const base = pricesIncludeTax ? taxable - tax : taxable;
    taxPercent = base > 0 ? Math.round((100 * tax) / base) : 0;
  }
  return { taxPercent: taxPercent ?? 0, pricesIncludeTax };
};
